import { Injectable } from '@angular/core';
import { Dexie, Table } from 'dexie';
import { Types } from 'shared-lib';
import { IDatabase } from '../../types/database.interface';

@Injectable({
  providedIn: 'root',
})
export class LibDexieDatabaseService extends Dexie implements IDatabase {
  imageCache!: Table<Types.IImageCacheSchema, number>;

  constructor() {
    super('tialtonivel.formToReport.lib');
    this.version(1).stores({
      imageCaches: '++dbid',
    });
  }

  initDb(): void {}

  remove<T, R>(table: T, id: Types.TChoice | undefined) {
    throw new Error('Method not implemented.');
  }

  async readAll<T, R>(table: T): Promise<R[]> {
    //@ts-ignore
    return await this[table]?.toArray();
  }

  async readOne<T, R>(
    table: T,
    id: Types.TChoice | undefined
  ): Promise<R | undefined> {
    if (!id || !['number', 'string'].includes(typeof id)) {
      return undefined;
    }
    //@ts-ignore
    const result = await this[table]?.where('id').equals(id).toArray();
    if (!result || result.length != 1) {
      return undefined;
    }
    return result.at(0);
  }

  async create<T, R>(table: T, entity: R) {
    //@ts-ignore
    return await this[table]?.add(entity);
  }

  async update<T, R>(table: T, entity: R) {
    //@ts-ignore
    return await this[table]?.add(entity);
  }

  // async remove<T>(table: Table<T, number>, id: number) {
  //   return (await this.readOne<IImageCacheSchema>(table, id))?.
  // }
}
